import { ISelectionTabProps } from "../../properties/TabProperties";
import SelectionTab from "./SelectionTab";

// SelectionTabFill — kept as a named export for existing call sites, but all
// selection tabs now render the unified morph SelectionTab.
const SelectionTabFill = ({
  optionList,
  selectedId,
  handleSelectOnClick,
}: ISelectionTabProps) => {
  return (
    <SelectionTab
      optionList={optionList}
      selectedId={selectedId}
      handleSelectOnClick={handleSelectOnClick}
    />
  );
};

export default SelectionTabFill;
